import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { setAutoSavedPending } from '../../../../actions/survey.sample.action';

const LabelItem = ({ label, index, hiddenLabel, onLabelChange, handleToggleHidden, draggableProvided }) => {
  const dispatch = useDispatch();

  return (
    <InputGroup
      ref={draggableProvided.innerRef}
      {...draggableProvided.draggableProps}
      {...draggableProvided.dragHandleProps}>
      <InputGroup.Text
        className='dragable'>
        <img src="/drag_drop_icon.png" alt="Bento Logo" />
      </InputGroup.Text>
      <Form.Control
        className="mt-3"
        id={label.id}
        value={label.value}
        disabled={hiddenLabel}
        type="text"
        onChange={(e) => onLabelChange(e, index)}
        onBlur={() => dispatch(setAutoSavedPending())}
      />
    </InputGroup>
  );
};

export default LabelItem;
